import { render, staticRenderFns } from "./order5.vue?vue&type=template&id=5f7ab124&scoped=true"
import script from "./order5.vue?vue&type=script&lang=js"
export * from "./order5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ab124",
  null
  
)

export default component.exports